import { useI18n } from "i18n";
import { useCallback, useState } from "react";
import { Button } from "@remo-co/ui-core/src/components/Button";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { useStyles } from "./EventAgendaButton.styles";
import EventAgendaPublic from "./EventAgendaPublic";
import EventAgendaContextProvider, {
  EVENT_AGENDA_CONTEXT,
} from "../eventAgenda/context/EventAgendaContext";

const EventAgendaButton = () => {
  const styles = useStyles();
  const { t } = useI18n(["event"]);
  const [isAgendaOpen, setIsAgendaOpen] = useState(false);

  const handleAgendaOpenClose = useCallback(() => {
    setIsAgendaOpen(!isAgendaOpen);
  }, [isAgendaOpen]);

  return (
    <>
      <EVENT_AGENDA_CONTEXT.Consumer>
        {({ state }) =>
          !state?.agendaItems.size ? null : (
            <Button
              variant="text"
              className={styles.agendaButton}
              onClick={handleAgendaOpenClose}
              data-testid="event-agenda-button"
              isIconButton
            >
              <Typography variant="h4">{t("event:top.bar.agenda")}</Typography>
            </Button>
          )
        }
      </EVENT_AGENDA_CONTEXT.Consumer>
      {isAgendaOpen && (
        <EventAgendaContextProvider isInEventSettings={false}>
          <EventAgendaPublic isOpen setIsOpen={setIsAgendaOpen} />
        </EventAgendaContextProvider>
      )}
    </>
  );
};

export default EventAgendaButton;
